// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"ccbdfd6e","513":"892bd862","787":"2b6886b3"}[chunkId] + ".chunk.js";
};